// src/pages/KitchenModeWrapper.js
import React from "react";
import KitchenMode from "./KitchenMode";

export default function KitchenModeWrapper() {
  return <KitchenMode />;
}
